export default __webpack_public_path__ + "static/media/Libya.ebb23b14.png";